import Card from './src/card';

module.exports = Card;


// WEBPACK FOOTER //
// ./src/components/card/index.js